var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',{staticStyle:{"padding-top":"100px"}},[_c('CCol',{attrs:{"col":"12"}},[_c('h1',[_vm._v("Hello Test --- "+_vm._s(_vm.id))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }